module.exports = __webpack_public_path__ + "static/ogre_battering_ram-58efb2136646e800bbe75b68a1848a55.png";